import { Injectable } from '@angular/core';
import { ParamMap } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { isNil, cloneDeep } from 'lodash-es';
import { ToastrService } from 'ngx-toastr';

import { WavelengthShellService } from 'wavelength-ui';
import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';


import { CleanupLoggerService } from './cleanup.logging.service';
import { app_pallet_activator_formComponent } from './app.pallet_activator_form.component';

import { Utilities_ShellService } from './Utilities.shell.service';
import { IntraOne_ShellService } from './IntraOne.shell.service';

@Injectable({ providedIn: 'root' })
export class app_ShellService extends WavelengthShellService  {
  constructor(
    dialog : MatDialog,
    toastr: ToastrService,
    private $logger: CleanupLoggerService,
    public Utilities: Utilities_ShellService,
    public IntraOne: IntraOne_ShellService,
  ) {
    super(dialog, toastr);
  }

  public app: app_ShellService = this;

  public openpallet_activator_form(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Pallet activator',
        referenceName: 'pallet_activator_form',
        component: app_pallet_activator_formComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openpallet_activator_formDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      app_pallet_activator_formComponent,
      'Pallet activator',
      mode,
      dialogSize
    )
  }

  public override getComponentInformation(referenceName: string, params: ParamMap): { title: string, component: any, inParams: any } {
    if (referenceName === 'pallet_activator_form') {
      const title = 'Pallet activator';
      const component = app_pallet_activator_formComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }


    let result = null;
    result = this.Utilities.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.IntraOne.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    return result;
  }
}
